import React, { PureComponent } from 'react';
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';

class Renovacion extends PureComponent {
    constructor(props) {
        super(props);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     */
    actualizarNovedadEstado(novedad, estadoId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, this.props.entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        this.props.selectCombo(0, this.props.codigoNovedad, event.target.value);
    }
    /**
     * 
     */
    render() {
        const { codigoPrecioRenovacion, codigoNovedad, empresaId, data, esNovedadEditada, funcionesDelUsuario, novedades, seEstaEditando, bonificacionesRenovacion } = this.props;

        let porcentajeBonificacionId = (data.porcentajeBonificacionId || 0);
        let porcentajeBonificacionDescripcion = "Sin especificar";
        let novedad = undefined;

        if (novedades && novedades.length > 0) {
            /*Busco el max id de las novedades generadas por la sucursal*/
            const novedadId = Math.max(...novedades.map(n => n.Id));
            /*Obtengo esa novedad*/
            novedad = novedades.find(n => n.Id == novedadId);

            if (novedad) {
                if (esNovedadEditada == false) {
                    porcentajeBonificacionId = novedad.ValorNovedad;
                }

                novedad.ValorAnteriorFormateado = "Sin especificar";
            }
        }

        bonificacionesRenovacion.forEach(s => {
            if (s.ID == porcentajeBonificacionId) {
                porcentajeBonificacionDescripcion = s.DESCRIPCION;
            }

            if (novedad) {
                if (s.ID == novedad.ValorAnterior) {
                    novedad.ValorAnteriorFormateado = s.DESCRIPCION;
                }
            }
        });

        const componente = (
            <select className="form-control default-select" value={porcentajeBonificacionId} onChange={this.selectCombo.bind(this)}>
                {(bonificacionesRenovacion || []).map((model, index) => {
                    return (
                        <option value={model.ID} key={"reno-option-" + index} data-codigo={model.CODIGO}>
                            {model.DESCRIPCION}
                        </option>
                    );
                })}
            </select>
        );

        return (
            <div className="row">
                <div className="col-xs-9">
                    <GenericEditPanel
                        componente={componente}
                        novedad={novedad}
                        permisoUsuario={funcionesDelUsuario}
                        seEstaEditando={seEstaEditando}
                        textPanel={porcentajeBonificacionDescripcion}
                        value={porcentajeBonificacionId}
                        title="Bonificación de la renovación"

                        aceptChanges={(value) => this.props.guardarNovedad(value)}
                        confirmarNovedad={() => this.actualizarNovedadEstado(novedad, 2)}
                        changeEditMode={(value) => this.props.estadoEdicion(value, codigoNovedad)}
                        denegarNovedad={() => this.actualizarNovedadEstado(novedad, 3)}
                        mostrarModificaciones={this.props.mostrarModal}
                        revert={this.props.cancelar}
                    />
                </div>
                <div className="col-xs-3">
                    <div>
                        <label className="label-primary">Código de precio de la renovación</label>
                    </div>
                    <div>
                        <label className="label-secondary">{codigoPrecioRenovacion}</label>
                    </div>
                </div>
            </div>
        );
    }
}

export default Renovacion;